import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default class CarouselMaker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  createCarouselElements = () => {
    let elems = [];
    const leng = this.props.imgSet.length;
    for (let i = 0; i < leng; i++) {
      elems.push(
        <img src={this.props.imgSet[i]} alt='img' />
      );
    }
    return elems;
  }
  render() {
    if (!this.props.hasOwnProperty('imgSet')) {
      return (<div />);
    }
    const settings = {
      dots: false,
      initialSlide: this.props.initNum,
    };
    // propsの特定の値の数だけ、div img を作る
    return (
      <div id='mierukaThumbnailCarousel'>
        <Slider {...settings}>
          {this.createCarouselElements()}
        </Slider>
      </div>
    );
  }
}
